<template>
    <div class="Shop">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'Shop'
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .Shop {
    }
</style>
